<template>
    <div id="div_publication">
        <!-- <h1>All Blog Articles</h1> -->
        <span style="float:right;">
            <label>Sorted by:</label>
            <select v-model="sortedBy">
                <option>year</option>
                <option>type</option>
            </select>
            <input type="text" v-model="search" placeholder="Search papers..." />
        </span>
        <div v-for="group in groupedPapers">
            <p class="p_keytag">{{ group.group }}</p>
            <div v-for="paper in group.papers" class="single-paper">
                <div id="div_bib">
                    <span class="p_title">{{ paper.title }},</span>
                    <span class="p_author">{{ paper.authorList }}.</span>
                    <span class="p_vennue">{{ paper.venue }} </span>
                    <span class="p_volume" v-if="paper.volume">({{ paper.volume }})</span>
                    <span class="p_issue" v-if="paper.issue">{{ paper.issue }}:</span>
                    <span class="p_pages" v-if="paper.pages">{{ paper.pages }}, </span>
                    <span class="p_year">{{ paper.year }}</span>
                    <span class="p_comments" v-if="paper.comments">({{ paper.comments }})</span>
                    <span class="p_award" v-if="paper.award">({{ paper.award }})</span>
                    <el-tag
                        :key="tag"
                        v-for="tag in paper.tags"
                        size="mini"
                        type="default"
                        :closable="false"
                        >
                        {{tag}}
                    </el-tag>
                    </br>
                    <a v-for="link in paper.links" v-bind:href="requestLocalData(link.herf)" class="link_data">
                        <img class="img_icon"  v-bind:src="requestLocalData(link.type)">
                        &nbsp;
                    </a>
                </div>
                <div id="div_img">
                    <img :src="requestLocalData(paper.image)" v-bind:alt="paper.image" class="img_publication">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Imports
import jsonPaper from '../assets/paper.json';
import { Tag } from 'element-ui'

export default {
    components:{
        [Tag.name]: Tag,
    },
    data () {
        return {
            papers: [],
            search: '',
            sortedBy: 'year'
        }
    },
    created() {
        this.papers = jsonPaper;
        this.papers.forEach(element => {
            element.authorList = element.authors.join(', ')
        });
    },
    methods: {
        requestLocalData(data) {
            if(data.slice(0, 4) == "http") {
                return data; // public url
            }
            else {// from local folder
                return require('../'+data);
            }
        },
    },
    computed: {
        groupedPapers: function(){
            var filtered = this.papers.filter((paper) => {
                return paper.title.match(this.search);
            });

            var sortKey = this.sortedBy;
            var paperGroup = []
            for(var i=0; i<filtered.length; i++) {
                var groupId = filtered[i][sortKey]
                var foundGroup = false;
                for(var j=0; j<paperGroup.length; j++) {
                    if(paperGroup[j]['group']==groupId) {
                        foundGroup = true;
                        paperGroup[j]['papers'].push(filtered[i]); 
                    }
                }
                if(!foundGroup) {
                    paperGroup.push({'group': groupId, 'papers': [filtered[i]]})
                }
            }
            return paperGroup;
        }
    }
}
</script>

<style scoped>
#div_publication{
    margin: 15px auto;
    padding-left: 10px;
    border-left: 2px solid #eeeeee;
}
.single-paper{
    padding: 10px;
    margin: 10px 0;
    box-sizing: border-box;
    background: #f2f2f2;
    border-radius: 8px 8px 8px 8px;
}
.single-paper:after { 
    content: " "; 
    display: block;
    clear: both;
    /* border-bottom: 2px solid #eeeeee;*/
} 
.p_keytag {
    font-weight: bold;
    font-size: 20px;
}
.p_title {
    color: #bb0000;;
}
.p_vennue{
    font-style: italic;
}
.p_award {
    font-weight: bold;
    color: red;
}
#div_bib {
    width:79%;
    float:left;
}
#div_img {
    width:20%;
    float:right;
}
.img_publication{
    width:100%;
    padding:1px;
    border:0px solid #021a40;
}
.link_data{/*remove underline for links*/
    text-decoration: none;
}
.img_icon{
    width: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/publication.vue